import { useTheme } from '@pnl/ui';

/**
 * Cores dos SVGs dos gráficos (recharts recebe cor literal, não enxerga as
 * CSS vars do tema). Re-renderiza junto com o toggle claro/escuro do sidebar.
 */
export function useChartColors() {
  const { resolvedTheme } = useTheme();
  const dark = resolvedTheme === 'dark';
  return {
    tick: dark ? '#FFFFFF' : '#334155',
    grid: dark ? '#2C2C2C' : '#E2E8F0',
    axis: dark ? '#5A5A5A' : '#64748B',
    baseline: dark ? '#FFFFFF' : '#0F172A',
  };
}
